import { http } from './http';
import { checkOrCreateChpoByDate, computeChpoDate } from './chpo';

// Общие приказы CHPO (если нужны для отображения в дальнейшем)
export async function listChpoOrders(params = {}) {
  const { data } = await http.get('chpo/orders/', { params });
  return data;
}

export async function getChpoOrder(id) {
  const { data } = await http.get(`chpo/orders/${id}/`);
  return data;
}

export async function createChpoOrder(payload) {
  const { data } = await http.post('chpo/orders/', payload);
  return data;
}

export async function updateChpoOrder(id, payload) {
  const { data } = await http.patch(`chpo/orders/${id}/`, payload);
  return data;
}

export async function deleteChpoOrder(id) {
  const { data } = await http.delete(`chpo/orders/${id}/`);
  return data;
}

// Получить приказ из CHPO-контекста (через chpo/check/)
export async function getChpoOrderFromContext(date) {
  const dateISO = date || computeChpoDate();
  const ctx = await checkOrCreateChpoByDate(dateISO);
  return ctx?.order || null;
}
